import { render, staticRenderFns } from "./FastCollectDialog.vue?vue&type=template&id=5a343459&scoped=true&"
import script from "./FastCollectDialog.vue?vue&type=script&lang=js&"
export * from "./FastCollectDialog.vue?vue&type=script&lang=js&"
import style0 from "./FastCollectDialog.vue?vue&type=style&index=0&id=5a343459&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a343459",
  null
  
)

export default component.exports